import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import { CollapsibleHedge } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import ReactModalHeader from '../Modal/ReactModalHeader';
import ReactModalContent from '../Modal/ReactModalContent';
import ReactModalFooter from '../Modal/ReactModalFooter';
import { modalActions, inputTilesActions } from '../../redux/root-action';
import { scroller } from 'react-scroll';
import { analyticsTracking } from 'utils/constants';

const StyledText = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 1.38;
  color: ${tokens.ColorGrey900};
  padding-top: 32px;
`;

const StyledImage = styled.img`
  margin: 32px 0px 32px 0px;
`;

const informationAndAssumptionsText =
  'Assumes the individual had a $50,000 annual salary and $250,000 in retirement savings at age 60 with 3% yearly inflation adjustments; 15% of earnings are contributed to a retirement plan until retirement; no Social Security benefits or contributions are drawn until retirement; savings earn 7% annually before retirement and 6% after retirement; amount represents current dollars at age 60, assuming a 3% discount rate; Social Security benefits rise 2.8% annually after initiation; savings are withdrawn at a rate of 4.1% for age 66 and rising 0.1% for each year retirement is delayed; the initial withdrawal increases yearly by 3% inflation. Social Security amounts are from the Social Security Administration’s website’s Quick Calculator. (assumes a 0% relative growth factor).';

class DelayRetirement extends Component<any, any> {
  handleTryDelayingRetirement = () => {
    const { hideModal, showInputTilePopover } = this.props;
    hideModal();
    showInputTilePopover('RetirementAge');
    scroller.scrollTo('strategy-container', {
      duration: 1500,
      delay: 0,
      smooth: 'easeInQuad',
    });
  };

  render(): JSX.Element {
    const mq = window.matchMedia('(max-width: 767px)');
    return (
      <React.Fragment>
        <ReactModalHeader modalTitle={'Working longer can pay off in retirement.'} showClose={true} />
        <ReactModalContent>
          <StyledText id={`delay-retirement`}>
            <div id={`delay-retirement-content-`}>
              Delaying retirement will give you more time to build your savings and allow you to maximize your Social
              Security benefit.
            </div>
            <br />
            <br />
            <b id={`delay-retirement-impact`}>Example: The impact of a 4-year delay</b>
            <br />
            <div id={`delay-retirement-saving`}>
              See how an individual with $250,000 in retirement savings at age 60 and a $50,000 annual salary benefits
              from a four-year delay.
            </div>
          </StyledText>
          {mq.matches ? (
            <StyledImage
              id={`delay-retirement-mobile-image`}
              alt="Delay retrirement"
              src={`data:image/svg+xml;base64,${tokens.AssetImageDelayRetirementMobile}`}
            />
          ) : (
            <StyledImage
              id={`delay-retirement-image`}
              alt="Delay retrirement"
              src={`data:image/svg+xml;base64,${tokens.AssetImageDelayRetirement}`}
            />
          )}
          <CollapsibleHedge
            id={`delay-retirement-collapsible-hedge`}
            tabIndex={0}
            title={'Information and Assumptions'}
            bodyCopy={informationAndAssumptionsText}
          />
        </ReactModalContent>
        <ReactModalFooter
          CTAButtonText="Adjust Retirement Age"
          handleCTAClick={this.handleTryDelayingRetirement}
          hideCancel={true}
          CTAButtonId={analyticsTracking.RIXActionTileDelayRetirementDelay}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any) => ({
  accountFields: state.addAccount,
});

export default connect(mapStateToProps, {
  hideModal: modalActions.hideModal,
  showInputTilePopover: inputTilesActions.showInputTilePopover,
})(DelayRetirement);
